import { HomepageHeader } from '@/types/homepage.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const updateHomepageHeaderReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<HomepageHeader>) => {
    if (state.workingProject && state.workingProject?.homepage) {
      state.workingProject = {
        ...state.workingProject,
        homepage: {
          ...state.workingProject.homepage,
          header: action.payload,
        },
      };
    }
  });
};

export default updateHomepageHeaderReducer;
